import { errorViolatesForeignKeyManager } from '@/services/validation/validation';

export default function validation(response, messages) {
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message !== null) {
      if (message.indexOf('NOMENCLATURE_TYPE_SCHEMA_VALIDATION') === 0) {
        messages.push({
          message: 'addEditNomenclatureType.error.schemaIsNotValid',
        });
      }
      errorViolatesForeignKeyManager(message, messages);
    }
  });
}
